import { AppRoutes } from '../../constants';

export const GOOGLE_ANALYTICS_CONSTANTS = {
    CODE: 'code',
    PROJECT_PE_MAPPING_ROUTE: AppRoutes.PROJECT_PE_MAPPING,
    ALLOWED_SUBDOMAINS: ['webapp.infollion.com', 'ext.infollion.com', 'webapp2.infollion.com']
};